const Fonts = () => {
  return (
    <>
      <link rel="preconnect" href="https://fonts.macpaw.com" crossOrigin="anonymous" />
      <link rel="stylesheet" href="https://fonts.macpaw.com/css?family=FixelVariable" />
    </>
  );
};

export default Fonts;
